import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiConfig from "../axiosConfig";
export const fetchLabels = createAsyncThunk("giftLabelManagement/fetchAssets", async () => {
	const response = await apiConfig.get("label-management/list");
	console.log("Labels List:{}", response);
	return response;
});
export const toggelDeleteGiftLabel = createAsyncThunk("giftLabelManagement/toggelDelete", async (labelId) => {
	const response = await apiConfig.delete(`label-management/delete/${labelId}`);
	const data = await response.data;
	return data;
});

export const addNewLabel = createAsyncThunk("giftLabelManagement/addNewLabel", async (rec_data) => {
	console.log("before send", rec_data);

	console.log("mood:", rec_data.isUpdate);
	if (!rec_data.isUpdate) {
		const responseWrapper = await apiConfig.post(`label-management/add`, rec_data.LabelData);
		return responseWrapper;
	} else {
		console.log("mood update:", rec_data.isUpdate);

		// update action
		const responseWrapper = await apiConfig.put(`label-management/update/${rec_data.LabelData.id}`, rec_data.LabelData);
		return responseWrapper;
	}
});
const giftLabelManagementSlice = createSlice({
	name: "giftLabelManagement",
	initialState: {
		assets: [],
		status: null,
		error: null,
	},
	reducers: {},
	extraReducers: {
		[fetchLabels.pending]: (state) => {
			console.log("Pending");
			state.status = "loading";
		},
		[fetchLabels.fulfilled]: (state, action) => {
			const response = action.payload.data;
			if (response.status === "OK") {
				state.status = "OK";
				state.assets = action.payload.data.data;
			} else {
				state.status = "failed";
				//state.error = action.error.message;
			}
		},
		[fetchLabels.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.error.message;
		},
		[toggelDeleteGiftLabel.fulfilled]: (state, action) => {
			const response = action.payload;

			if (response.status === "OK") {
				const itemIndex = state.assets.findIndex((item) => item.id === action.payload.data.id);
				state.assets[itemIndex] = action.payload.data;
			} else {
				state.status = "failed";
				state.error = action.error.message;
			}
		},
		[addNewLabel.fulfilled]: (state, action) => {
			const response = action.payload.data;

			if (response.status === "OK") {
				const itemIndex = state.assets.findIndex((item) => item.id === action.payload.data.data.id);
				if (itemIndex === -1) {
					state.assets = [...state.assets, action.payload.data.data];
				} else {
					state.assets[itemIndex] = action.payload.data.data;
				}
			} else {
				state.status = "failed";
				state.error = action.error.message;
			}
		},
	},
});
export const assetManagementActions = giftLabelManagementSlice.actions;
export default giftLabelManagementSlice.reducer;
